import { render, staticRenderFns } from "./HairDye.vue?vue&type=template&id=0a703ad3&scoped=true&"
import script from "./HairDye.vue?vue&type=script&lang=js&"
export * from "./HairDye.vue?vue&type=script&lang=js&"
import style0 from "./HairDye.vue?vue&type=style&index=0&id=0a703ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a703ad3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
